var React = require('react');

function IronOk (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #1d1d1b;\n        stroke-miterlimit: 10;\n        stroke-width: 1.8px;\n      }\n    ")),React.createElement("g",{"id":"Layer_1","data-name":"Layer 1","key":1},[React.createElement("path",{"className":"cls-1","d":"M11.82.9h47.49l10.16,49.25H1.5l13.36-24.9c1.42-2.5,3.91-4.01,6.57-4.01h32.94","key":0}),React.createElement("circle",{"className":"cls-1","cx":"35.42","cy":"36.99","r":"3.81","key":1})])]);
}

IronOk.defaultProps = {"id":"Capa_2","data-name":"Capa 2","viewBox":"0 0 70.58 51.05"};

module.exports = IronOk;

IronOk.default = IronOk;
